<script setup>
  import { ref, onMounted } from "vue"

  const mapContainer = ref(undefined)

  let mapSession = undefined
  let targetAreaController = undefined

  onMounted(async () => {
    // Create the MapSessions for the two maps
    mapSession = window.Kestrel.createMapSession(mapContainer.value, "map-container")

    mapSession.initialize({
      loadCountryOptions: false,
      countryIso3Code: 'TGO',
      simplificationStack: { 4: 0 },
      kestrelApiKey: "KESTREL API KEY",
    }).then(async (ms) => {
      // Add zoom conrols
      ms.addZoomControl()

      // Initialize the target area controller
      targetAreaController = new Kestrel.TargetAreaController(ms, {
        // EDIT MODE (optional)
        targetAreaId: "bca2114d-77b5-4495-bbdf-ca0c4739d881",

        description: () => "Target Area", // or can just be a normal string
        orgCode: 'TTI',

        centerLatitude: 8.5, 
        centerLongitude: 1.0,
        radius: radius.value,
        renderCircle: true,
        targetAreaBaseUrl: "https://localhost:3000/api",
        shading: {
          type: "ishare",
          includeSurveyData: true,
          apiKey: 'API KEY',
          apiUser: 'API USER',
        },

        extraTargetAreaParameters: {
          training_center_id: 15,
        },
      })
    })    
  })


  // Radius Adjustment
  const radius = ref(10)
  function setRadius () {
    if (!targetAreaController) { return }
    targetAreaController.setCenterRadius(radius.value)
  }
  

  // Village Labels Toggle
  const labelType = ref('name')
  function toggleVillageLabels () {
    if (!targetAreaController) { return }
    targetAreaController.setVillageLabels(labelType.value)
  }

  async function createTargetArea () {
    if (!targetAreaController) { return }
    await targetAreaController.createNewTargetArea()
  }

  async function updateTargetArea () {
    if (!targetAreaController) { return }
    await targetAreaController.updateExistingTargetArea()
  }
</script>

<template>
  <div class="flex flex-col justify-center items-center ">
    <div class="flex flex-row justify-between items-center w-full p-5">

      <!-- Start Radius Slider -->
      <div class="slidecontainer max-w-xl">
        <input id="radius-slider" type="range" min="1" max="30"
          class="slider"
          v-model="radius"
          @change="setRadius"
        />
      </div>
      <!-- End Radius Slider -->

      <!-- Start Village Toggle -->
      <div  class="flex flex-col justify-center items-center">
          <div class="toggle-history-container" style="display: flex;flex-direction: column;align-items: flex-end;">
          <div class="toggle-village-labels" style="margin-bottom:10px;">
            <span class="mr-2"><b>Village Labels:</b></span>

            <input class="mr-1" type="radio" id="villageNumber" value="number" v-model="labelType" @change="toggleVillageLabels">
            <label class="mr-2" for="villageNumber">Village #</label>

            <input class="mr-1" type="radio" id="villageName" value="name" v-model="labelType" @change="toggleVillageLabels">
            <label class="mr-2"  for="villageName">Village Name</label>

            <input class="mr-1" type="radio" id="noLabels" value="none" v-model="labelType" @change="toggleVillageLabels">
            <label class="mr-2" for="noLabels">None</label>
          </div>

        </div>
      </div>
      <!-- End Village Toggle -->

      <!-- Start Create Target Area Button -->
      <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" @click="createTargetArea">Create Target Area</button>
      <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" @click="updateTargetArea">Update Target Area</button>
      <!-- End Create Target Area Button -->

    </div>
    
    <div class="container mx-auto sm:px-6 lg:px-8 h-[calc(85vh-220px)] z-0 overflow-hidden flex flex-row mb-10">
      <div id="map-container" ref="mapContainer" class="flex-1 z-0 overflow-hidden border-4 border-l-2 border-gray-300"></div>
    </div>
  </div>
</template>


<style scoped>
.slidecontainer {
  width: 100%; /* Width of the outside container */
}

/* The slider itself */
.slider {
  -webkit-appearance: none;  /* Override default CSS styles */
  appearance: none;
  width: 100%; /* Full-width */
  height: 25px; /* Specified height */
  background: #d3d3d3; /* Grey background */
  outline: none; /* Remove outline */
  opacity: 0.7; /* Set transparency (for mouse-over effects on hover) */
  -webkit-transition: .2s; /* 0.2 seconds transition on hover */
  transition: opacity .2s;
}

/* Mouse-over effects */
.slider:hover {
  opacity: 1; /* Fully shown on mouse-over */
}

/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
.slider::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
  appearance: none;
  width: 25px; /* Set a specific slider handle width */
  height: 25px; /* Slider handle height */
  background: #04AA6D; /* Green background */
  cursor: pointer; /* Cursor on hover */
}

.slider::-moz-range-thumb {
  width: 25px; /* Set a specific slider handle width */
  height: 25px; /* Slider handle height */
  background: #04AA6D; /* Green background */
  cursor: pointer; /* Cursor on hover */
}
</style>